export default {
    uploadNewMediaToDb: '/mediaLibrary/uploadNewMediaToDb',
    getMediaLibrary: '/mediaLibrary/getMediaLibrary',
    updateMediaById: '/mediaLibrary/updateMediaById',
    deleteMediaById: '/mediaLibrary/deleteMediaById',
    getSignedUrl: "/spaces/presigned_url",
    getMediaSignedUrl: "/mediaLibrary/getMediaSignedUrl",
    getPresignedUrlForR2: "/mediaLibrary/getPresignedUrlForR2"
}